var map = {
	"./@.svg": 2462,
	"./Group.svg": 9192,
	"./Gruppe 1036.svg": 9430,
	"./Gruppe 37491.svg": 1090,
	"./amount-blue.svg": 9100,
	"./amount-dark-blue.svg": 850,
	"./amount-dark-gray.svg": 4168,
	"./amount-dark-white.svg": 8300,
	"./amount-empty.svg": 8971,
	"./amount-gray.svg": 7309,
	"./arrow-blue.svg": 5559,
	"./arrow-white.svg": 8210,
	"./bag-onsite.svg": 8862,
	"./bell-gray.svg": 4808,
	"./calendar-blue.svg": 3694,
	"./calendar-gray.svg": 363,
	"./calendar-white.svg": 7005,
	"./cancel-white.svg": 3441,
	"./cancel.svg": 2045,
	"./chat.svg": 8701,
	"./checkmark-blue.svg": 6651,
	"./checkmark-gray.svg": 8317,
	"./checkmark.svg": 5058,
	"./circle-blue-full.svg": 7746,
	"./circle-dark-blue-full.svg": 1677,
	"./circle-dark-gray-full.svg": 2318,
	"./circle-dark-green-full.svg": 7084,
	"./circle-gray-full.svg": 389,
	"./circle-green-empty.svg": 2245,
	"./circle-green-full.svg": 649,
	"./circle-red-full.svg": 1229,
	"./circle-weak-red-full.svg": 7840,
	"./clock-gray.svg": 6041,
	"./clock.svg": 2075,
	"./close-gray.svg": 2071,
	"./close-red.svg": 3447,
	"./close-x.svg": 886,
	"./construction-site.svg": 2556,
	"./contracts-empty.svg": 8088,
	"./email-icon.svg": 8917,
	"./error_warning-bright-red.svg": 6517,
	"./error_warning-dark-red.svg": 5557,
	"./error_warning-red.svg": 5764,
	"./error_warning.svg": 6414,
	"./eye.svg": 4426,
	"./eye_off.svg": 6096,
	"./filter.svg": 7985,
	"./go-to-arrow.svg": 469,
	"./go-to.svg": 7841,
	"./home.svg": 4174,
	"./icon-bell-small-blue.svg": 8557,
	"./icon-bell-small.svg": 8836,
	"./icon-binding-request.svg": 8940,
	"./icon-cancellation-request.svg": 3576,
	"./icon-change-request.svg": 9393,
	"./icon-checking.svg": 8297,
	"./icon-delivery-cancelled.svg": 2319,
	"./icon-delivery-confirmed.svg": 7001,
	"./icon-delivery-refused.svg": 3830,
	"./icon-in-review.svg": 7069,
	"./icon-pencil-white.svg": 3930,
	"./icon-pencil.svg": 5934,
	"./icon-planned.svg": 7845,
	"./logout.svg": 4277,
	"./maintenance.svg": 7324,
	"./menu-close.svg": 8333,
	"./menu.svg": 2434,
	"./mobile-phone-icon.svg": 1840,
	"./moon.svg": 5247,
	"./notifications.svg": 7497,
	"./phone-icon.svg": 93,
	"./phone.svg": 6345,
	"./qr-code-scanner.svg": 4157,
	"./question-mark.svg": 7631,
	"./refresh-gray.svg": 788,
	"./scanner.svg": 2664,
	"./search.svg": 4343,
	"./settings.svg": 716,
	"./shield.svg": 6164,
	"./simple-loading.svg": 9962,
	"./star-border.svg": 9794,
	"./star.svg": 815,
	"./success-icon.svg": 4662,
	"./telephone.svg": 4081,
	"./truck.svg": 1964,
	"./user-big.svg": 7879,
	"./user-icon.svg": 7604,
	"./user.svg": 698,
	"./x-bright-red.svg": 3572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;